"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("./util/constants");

var DataSync = _interopRequireWildcard(require("./util/DataSync"));

var Log = _interopRequireWildcard(require("./util/Log"));

var _cache = _interopRequireDefault(require("./util/cache"));

var _Room = _interopRequireDefault(require("./Room"));

var Events = _interopRequireWildcard(require("../definitions/Events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Update
 * @param {Invite} invite The invite
 * @param {string} status The new status
 * @param {string} [reason=null] The reason (a message)
 * @param {object} [_ended=null]
 * @access private
 * @returns {Promise<Invite, Error>}
 */
var update = function update(invite, status) {
  var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var _ended = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var values = {
    status: status,
    reason: reason,
    _ended: _ended
  };

  if (invite.status !== _constants.ONGOING) {
    return Promise.reject(new Error('This invitation has already been answered'));
  }

  return DataSync.update("_/invites/".concat(invite.to, "/").concat(invite.uid), values).then(function () {
    Object.keys(values).forEach(function (prop) {
      invite[prop] = values[prop]; // eslint-disable-line no-param-reassign
    });
    return _Room.default.get(invite.room);
  }).then(function () {
    return {
      invite: invite
    };
  }).catch(Log.r('Invite_update'));
};
/**
 * Invitation
 * @public
 */


var Invite =
/*#__PURE__*/
function () {
  /**
   * Create an invite
   * @param {Webcom/api.DataSnapshot|object} snapData The data snapshot
   * @access protected
   */
  function Invite(snapData) {
    _classCallCheck(this, Invite);

    var values = snapData;

    if (snapData && snapData.val && typeof snapData.val === 'function') {
      values = Object.assign({}, snapData.val(), {
        uid: snapData.name(),
        to: snapData.ref().parent().name()
      });
    }
    /**
     * Invite's unique id
     * @type string
     */


    this.uid = values.uid;
    /**
     * Invite's sender uid
     * @type {string}
     */

    this.from = values.from;
    /**
     * Invitee's uid
     * @type {string}
     */

    this.to = values.to;
    /**
     * The id of the room associated to the invite
     * @type {string}
     */

    this.room = values.room;
    /**
     * The invitation status :
     * - ONGOING - The receiver has not yet responded to the invitation
     * - ACCEPTED - The receiver has accepted the invitation
     * - REJECTED - The receiver has rejected the invitation
     * - CANCELED - The sender canceled the invitation
     * @type {string}
     */

    this.status = values.status;
    /**
     * Invite message. This will be either a custom message,
     * if the status is ONGOING or a reason when status is CANCELED|REJECTED.
     * @type {string}
     */

    this.topic = values.topic;
    /**
     * Invite creation timestamp
     * @type {number}
     */

    this._created = values._created;
    /**
     * Invite expiration timestamp
     * @type {number}
     */

    this._ended = values._ended;
    /**
     * Invite events callbacks
     * @type {{}}
     * @private
     */

    this._callbacks = {};
  }
  /**
   * Is this invitation waiting for a reply ?
   * @type {boolean}
   */


  _createClass(Invite, [{
    key: "cancel",

    /**
     * Cancels the invitation. Only the sender can cancel the invitation.
     * @param {string} [reason] The reason the sender is canceling the invite
     * @return {Promise<Invite>}
     */
    value: function cancel(reason) {
      return update(this, _constants.CANCELED, reason, DataSync.ts());
    }
    /**
     * Rejects the invitation. Only the receiver can reject the invitation.
     * @param {string} [reason] The reason the receiver is rejecting the invite
     * @return {Promise<Invite>}
     */

  }, {
    key: "reject",
    value: function reject(reason) {
      return update(this, _constants.REJECTED, reason, DataSync.ts());
    }
    /**
     * Accept the invitation. Only the receiver can accept the invitation.
     * @return {Promise<Invite>}
     */

  }, {
    key: "accept",
    value: function accept() {
      return update(this, _constants.ACCEPTED);
    }
    /**
     * Register a callback for a status update
     * @param {string} status Can be:
     * - ACCEPTED
     * - REJECTED
     * - CANCELED
     * @param {function} callback
     */

  }, {
    key: "on",
    value: function on(status, callback) {
      var _this = this;

      if (Events.invite.supports(status)) {
        // Register callback
        if (!this._callbacks[status]) {
          this._callbacks[status] = [];
        }

        this._callbacks[status].push(callback); // Defined listener & subscribe if needed


        if (!this._listener) {
          /**
           * Invite status update callback
           * @type {function}
           * @private
           */
          this._listener = function (snapData) {
            var updated = snapData.val();

            if (updated !== null && updated !== _this.status) {
              _this.status = updated;
              (_this._callbacks[updated] || []).forEach(function (cb) {
                cb(_this);
              });
            }
          };

          DataSync.on("_/invites/".concat(this.to, "/").concat(this.uid, "/status"), 'value', this._listener.bind(this));
        }
      }
    }
    /**
     * Register a callback for all status change events
     * @param {function} callback
     */

  }, {
    key: "onStatusChange",
    value: function onStatusChange(callback) {
      var _this2 = this;

      [_constants.ACCEPTED, _constants.REJECTED, _constants.CANCELED].forEach(function (event) {
        _this2.on(event, callback);
      });
    }
    /**
     * Un-register a callback for a status update
     * @param {string} [status] Can be:
     * - ACCEPTED
     * - REJECTED
     * - CANCELED
     * - null This will un-register all callbacks
     * @param {function} [callback]
     */

  }, {
    key: "off",
    value: function off(status, callback) {
      var _this3 = this;

      if (!status) {
        this._callbacks = {};
      } else if (this._callbacks[status]) {
        if (callback) {
          var idx = this._callbacks[status].findIndex(function (cb) {
            return cb === callback;
          });

          if (idx >= 0) {
            this._callbacks.splice(idx, 1);
          }
        } else {
          this._callbacks[status] = [];
        }
      }

      if (![_constants.CANCELED, _constants.ACCEPTED, _constants.REJECTED].some(function (event) {
        return _this3._callbacks[event] && _this3._callbacks[event].length > 0;
      })) {
        DataSync.off("_/invites/".concat(this.to, "/").concat(this.uid, "/status"), 'value');
      }
    }
    /**
     * Un-register a callback for all status change events
     * @param {function} [callback]
     */

  }, {
    key: "offStatusChange",
    value: function offStatusChange(callback) {
      var _this4 = this;

      if (!callback) {
        this.off();
      } else {
        [_constants.ACCEPTED, _constants.REJECTED, _constants.CANCELED].forEach(function (event) {
          _this4.off(event, callback);
        });
      }
    }
    /**
     * Create the invitation & add the user to the participants list
     * @access protected
     * @param {User} invitee The user to invite
     * @param {Room} room The room to invite the user to
     * @param {string} [message] A message for the invitee
     */

  }, {
    key: "isOnGoing",
    get: function get() {
      return this.status === _constants.ONGOING;
    }
    /**
     * Was this invitation rejected ?
     * @type {boolean}
     */

  }, {
    key: "isRejected",
    get: function get() {
      return this.status === _constants.REJECTED;
    }
    /**
     * Was this invitation accepted ?
     * @type {boolean}
     */

  }, {
    key: "isAccepted",
    get: function get() {
      return this.status === _constants.ACCEPTED;
    }
    /**
     * Was this invitation canceled ?
     * @type {boolean}
     */

  }, {
    key: "isCanceled",
    get: function get() {
      return this.status === _constants.CANCELED;
    }
  }], [{
    key: "send",
    value: function send(invitee, room) {
      var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!_cache.default.user) {
        return Promise.reject(new Error('Only an authenticated user can send an invite.'));
      }

      var inviteMetaData = {
        from: _cache.default.user.uid,
        room: room.uid,
        status: _constants.ONGOING,
        _created: DataSync.ts(),
        topic: message
      };
      return DataSync.push("_/invites/".concat(invitee.uid), inviteMetaData).then(function (inviteRef) {
        var inviteId = inviteRef.name();
        return new Invite(Object.assign({
          uid: inviteId,
          to: invitee.uid
        }, inviteMetaData));
      }).catch(Log.r('Invite#send'));
    }
  }]);

  return Invite;
}();

exports.default = Invite;